// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import builderFetch
import { builderFetch } from '../../utils';

/**
 * Runs the recipe on demand
 *
 * @return {Promise} The apiFetch promise
 */
const runRecipe = () => {
	// Event name
	const eventName = 'uap/builder/core/run-recipe';

	// Run the recipe
	return builderFetch( {
		eventName: eventName,
		endpoint: `run-now/start/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		snackbar: {
			loading: escapeHTML( __( 'Starting recipe', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Recipe started successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName ) );
		}

		return response;
	} );;
}

export default runRecipe;
